var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { FieldSuggest } from "../";

import "./GeocoderSearch.scss";

import { fitBounds } from 'google-map-react/utils';

var PROXY = "https://cors-anywhere.herokuapp.com/";
var GEOCODE_URL = PROXY + "https://maps.googleapis.com/maps/api/geocode/json";
var AUTOCOMPLETE_URL = PROXY + "https://maps.googleapis.com/maps/api/place/autocomplete/json";
var DETAILS_URL = PROXY + "https://maps.googleapis.com/maps/api/place/details/json";

var TOKEN = "test";

var GeocoderSearch = (_temp2 = _class = function (_Component) {
    _inherits(GeocoderSearch, _Component);

    function GeocoderSearch() {
        var _temp, _this, _ret;

        _classCallCheck(this, GeocoderSearch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            placeId: undefined,
            q: "",
            autocomplete: [],
            results: []
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.center !== _this.props.center) {
                _this.getQuery();
            }

            if (prevProps.lat !== _this.props.lat || prevProps.lng !== _this.props.lng) {
                _this.getQuery();
            }
        }, _this.getQuery = function () {
            var _this$props = _this.props,
                placeId = _this$props.placeId,
                center = _this$props.center,
                lat = _this$props.lat,
                lng = _this$props.lng;


            var latlng = void 0;

            if (lat && lng) {
                latlng = lat + ',' + lng;
            } else if (center) {
                latlng = center.lat + ',' + center.lng;
            }

            if (!placeId && latlng) {

                _this.requestGeocode(latlng);

                _this.setState({
                    //                q: latlng
                });
            }
        }, _this.onChange = function (props) {
            console.log("geocoder:onChange", props);
            var placeId = props.placeId,
                viewport = props.viewport,
                center = props.center,
                zoom = props.zoom;


            _this.setState({
                placeId: placeId
            });

            if (_this.props.onChange) {
                _this.props.onChange(_extends({}, props));
            }
        }, _this.getAddressComponents = function (components) {

            var country = void 0,
                countryCode = void 0,
                route = void 0,
                streetNumber = void 0,
                postalTown = void 0,
                postalCode = void 0;

            components.map(function (component) {
                var long_name = component.long_name,
                    short_name = component.short_name,
                    types = component.types;


                if (types.includes('country')) {
                    country = long_name;
                    countryCode = short_name;
                }

                if (types.includes('route')) {
                    route = long_name;
                }

                if (types.includes('street_number')) {
                    streetNumber = long_name;
                }

                if (types.includes('postal_code')) {
                    postalCode = long_name;
                }

                if (types.includes('postal_town')) {
                    postalTown = long_name;
                }
            });

            return {
                country: country || false,
                countryCode: countryCode || false,
                route: route || false,
                streetNumber: streetNumber || false,
                postalTown: postalTown || false,
                postalCode: postalCode || false
            };
        }, _this.onSelectResult = function (result) {
            var place_id = result.place_id,
                formatted_address = result.formatted_address,
                address_components = result.address_components,
                geometry = result.geometry;
            var location = geometry.location,
                viewport = geometry.viewport;


            var bounds = {
                ne: viewport.northeast,
                sw: viewport.southwest
            };

            var size = {
                width: 300, // Map width in pixels
                height: 300 // Map height in pixels
            };

            var _fitBounds = fitBounds(bounds, size),
                center = _fitBounds.center,
                zoom = _fitBounds.zoom;

            var addressComponents = _this.getAddressComponents(address_components);

            _this.setState({
                results: [result]
            });

            _this.onChange(_extends({
                source: 'geocoder',
                placeId: place_id,
                center: location,
                lat: location.lat,
                lng: location.lng,
                viewport: viewport,
                zoom: zoom,
                address: formatted_address
            }, addressComponents));
        }, _this.receiveDetails = function (data) {
            var result = data.result;

            _this.onSelectResult(result);
        }, _this.requestDetails = function (id) {
            var _this$props2 = _this.props,
                API_KEY = _this$props2.API_KEY,
                language = _this$props2.language;


            var url = DETAILS_URL + "?placeid=" + id + "&language=" + language + "&key=" + API_KEY + "&sessiontoken=" + TOKEN + "&fields=place_id,name,type,address_component,formatted_address,geometry,opening_hours";

            fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            }).then(function (response) {
                return response.json();
            }, function (error) {
                return console.log('An error occurred.', error);
            }).then(function (data) {
                return _this.receiveDetails(data);
            });
        }, _this.receiveGeocode = function (data) {
            var results = data.results;


            if (!results.length) {
                return;
            }

            _this.setState({
                q: "",
                autocomplete: [],
                results: results
            });
        }, _this.requestGeocode = function (address) {
            var _this$props3 = _this.props,
                API_KEY = _this$props3.API_KEY,
                language = _this$props3.language;


            var url = GEOCODE_URL + "?address=" + address + "&language=" + language + "&key=" + API_KEY + "&sessiontoken=" + TOKEN + "&fields=place_id,name,type,address_component,formatted_address,geometry,opening_hours";

            fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            }).then(function (response) {
                return response.json();
            }, function (error) {
                return console.log('An error occurred.', error);
            }).then(function (data) {
                return _this.receiveGeocode(data);
            });
        }, _this.receiveAutocomplete = function (data) {
            var predictions = data.predictions;


            var autocomplete = [];

            predictions.map(function (prediction) {
                var place_id = prediction.place_id,
                    description = prediction.description,
                    structured_formatting = prediction.structured_formatting;
                var main_text = structured_formatting.main_text,
                    secondary_text = structured_formatting.secondary_text;


                autocomplete.push({
                    placeId: place_id,
                    title: main_text,
                    description: description
                });
            });

            _this.setState({
                autocomplete: autocomplete
            });
        }, _this.requestAutocomplete = function (q) {
            var _this$props4 = _this.props,
                API_KEY = _this$props4.API_KEY,
                language = _this$props4.language;


            _this.setState({
                autocomplete: [],
                results: []
            });

            var url = AUTOCOMPLETE_URL + "?input=" + q + "&language=" + language + "&key=" + API_KEY + "&sessiontoken=" + TOKEN;

            fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            }).then(function (response) {
                return response.json();
            }, function (error) {
                return console.log('An error occurred.', error);
            }).then(function (data) {
                return _this.receiveAutocomplete(data);
            });
        }, _this.onSuggestSearch = function (q) {

            if (q) {
                _this.requestAutocomplete(q);
            } else {
                _this.setState({
                    autocomplete: []
                });
            }
        }, _this.onSuggestInput = function (value, event) {

            _this.setState({
                q: value
            });
        }, _this.onSuggestSelect = function (item) {
            console.log("geocoder:onSelect", item);

            var placeId = item.placeId,
                title = item.title,
                description = item.description;


            _this.requestDetails(placeId);

            _this.setState({
                placeId: placeId
            });

            return title;
        }, _this.renderItem = function (item) {
            var placeId = item.placeId,
                title = item.title,
                description = item.description;


            return React.createElement(
                "div",
                { className: "admin-geocoder__prediction" },
                React.createElement(
                    "h2",
                    null,
                    title
                ),
                React.createElement(
                    "p",
                    null,
                    description
                )
            );
        }, _this.renderResult = function (result, index) {
            var place_id = result.place_id,
                formatted_address = result.formatted_address;


            var item = {
                description: formatted_address
            };

            return React.createElement(
                "li",
                { className: "admin-field__suggest-item", key: index, onClick: function onClick() {
                        return _this.onSelectResult(result);
                    } },
                _this.renderItem(item)
            );
        }, _this.renderResults = function () {
            var results = _this.state.results;


            if (!results.length) {
                return false;
            }

            return React.createElement(
                "div",
                { className: "admin-geocoder__results" },
                React.createElement(
                    "ul",
                    { className: "admin-field__suggest-list" },
                    results.map(_this.renderResult)
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    GeocoderSearch.prototype.render = function render() {
        var _state = this.state,
            q = _state.q,
            autocomplete = _state.autocomplete;
        var placeholder = this.props.placeholder;


        return React.createElement(
            "div",
            { className: "admin-geocoder__search" },
            React.createElement(FieldSuggest, { value: q,
                placeholder: placeholder,
                suggestions: autocomplete,
                onSelect: this.onSuggestSelect,
                onSuggest: this.onSuggestSearch,
                onChange: this.onSuggestInput,
                renderItem: this.renderItem
            }),
            this.renderResults()
        );
    };

    return GeocoderSearch;
}(Component), _class.defaultProps = {
    API_KEY: "AIzaSyA0UKwjqalA0BdK5GBh8RPR9HJjtifWLAg",
    language: "no"
}, _temp2);


export default GeocoderSearch;